import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { fmtDate } from '../../../../utils/fmt';

const OpportunityHistoryListDetails = () => {
  const { opportunityId } = useParams();
  const [opportunity, setOpportunity] = useState(null);
  const [history, setHistory] = useState([]);
  const [users, setUsers] = useState({});

  useEffect(() => {
    fetchOpportunityDetails();
    fetchOpportunityHistory();
    fetchUsers();
  }, [opportunityId]);

  const fetchOpportunityDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunity}${opportunityId}/`, { headers });
      setOpportunity(Array.isArray(response.data) ? response.data : (response.data?.data ?? []));
    } catch (error) {
      console.error('Error fetching opportunity details:', error);
    }
  };

  const fetchOpportunityHistory = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunityHistory}${opportunityId}/`, { headers });
      setHistory(Array.isArray(response.data) ? response.data : (response.data?.data ?? []));
    } catch (error) {
      console.error('Error fetching opportunity history:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.users}`, { headers });
      const userMap = (Array.isArray(response.data) ? response.data : (response.data?.data ?? [])).reduce((acc, user) => {
        acc[user.id] = user.username;
        return acc;
      }, {});
      setUsers(userMap);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const columns = [
    { label: 'Action', value: 'action' },
    { 
      label: 'User', 
      value: (item) => users[item.username] || 'Unknown User'  // Use the user map to get the username
    },
    { label: 'Date', value: (item) => fmtDate(item.date) },
    { label: 'Details', value: 'details' },
  ];

  return (
    <div>
     

      <ListTemplate
        columns={columns}
        data={history}
        title="Opportunity History"
      />
    </div>
  );
};

export default OpportunityHistoryListDetails;
